<template>
  <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
    <template slot="header">
      <div class="col-8">
        <h4 class="card-title">Segment / Dal Bazlı Karşılaştırma</h4>
        <p class="card-category">Her dalın kumbara ve gecikme durumu (kendi altındaki tüm alt dallar dahil)</p>
      </div>
      <div style="text-align: right;" class="col-4 card-title">
        <a-button icon="download" @click="exportCsv" :disabled="!rows.length">
          Excel'e Aktar
        </a-button>
      </div>
    </template>
    <a-table rowKey="segment_id" :columns="columns" :data-source="sortedRows" :pagination="{ pageSize: 10 }">
      <span slot="rate" slot-scope="text, record">
        <a-tag :color="rateColor(record.overdue_rate)">{{ record.overdue_rate.toFixed(0) }}%</a-tag>
      </span>
    </a-table>
  </card>
</template>

<script>
import { mapState } from 'vuex'
import Card from 'src/components/Cards/Card.vue'

export default {
  components: { Card },
  computed: {
    ...mapState({
      rows: (state) => state.Reports.segment_breakdown,
    }),
    sortedRows() {
      return this.rows.slice().sort((a, b) => b.overdue_rate - a.overdue_rate)
    },
  },
  mounted() {
    this.$store.dispatch('Reports/requestSegmentBreakdown')
  },
  methods: {
    rateColor(rate) {
      if (rate >= 50) return 'red'
      if (rate > 0) return 'orange'
      return 'green'
    },
    exportCsv() {
      this.$exportToCsv(
        'segment_karsilastirma',
        [
          { title: 'Segment', key: 'segment_name' },
          { title: 'Tip', key: 'segment_type_name' },
          { title: 'Kumbara Sayısı', key: 'moneybox_count' },
          { title: 'Gecikmiş', key: 'overdue_count' },
          { title: 'Gecikme Oranı (%)', key: 'overdue_rate' },
        ],
        this.sortedRows
      )
    },
  },
  data() {
    return {
      columns: [
        { title: 'Segment', dataIndex: 'segment_name', key: 'segment_name' },
        { title: 'Tip', dataIndex: 'segment_type_name', key: 'segment_type_name' },
        { title: 'Kumbara Sayısı', dataIndex: 'moneybox_count', key: 'moneybox_count' },
        { title: 'Gecikmiş', dataIndex: 'overdue_count', key: 'overdue_count' },
        { title: 'Gecikme Oranı', key: 'rate', scopedSlots: { customRender: 'rate' } },
      ],
    }
  },
}
</script>
